import { SHA256, enc } from 'crypto-js';

const isEmail = email => {
    // Regular expression for basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // Test the email against the regex
    return emailRegex.test(email);
};

const { $$epiforms, dataLayer, trackerSettings } = window;

if (typeof $$epiforms !== 'undefined') {
    let fieldsCompleted = 0;

    if (trackerSettings && trackerSettings?.enableTracking) {
        // Variables
        const { formName, userType } = trackerSettings;

        // Functions
        const pushFormStart = () => {
            fieldsCompleted = fieldsCompleted + 1;
            if (fieldsCompleted === 1) {
                dataLayer.push({
                    event: 'custom.form.start',
                    // eslint-disable-next-line no-undef
                    form: formName,
                    action: 'start',
                });
            }
        };

        // Helper function to grab the input element by its label.
        // We can't set it manually, so we'll have to depend on the labels.
        const getEpiformFieldByLabel = (fieldType, fieldLabel, inputType) => {
            // get all of the form elements, could be FormSelection, FormTextbox, FormChoice, etc
            const fields = [...window.$$epiforms(fieldType)];

            if (!fields || fields.length === 0) {
                return null;
            }
            // filter the fields, look for the queried element
            const result = fields.filter(field => {
                return field.querySelector('label')?.innerHTML?.toLowerCase().includes(fieldLabel);
            });

            if (result.length < 1) {
                return null;
            }
            // the result should return the whole FormSelection div, return only the desired input type.
            return result[0].querySelector(inputType);
        };

        // Event Listeners

        // on Form submit
        $$epiforms('.EPiServerForms').on('formsSubmitted', event => {
            // Track success submission
            if (event.isFinalizedSubmission && event.isSuccess) {
                let hashedEmail = '';
                const data = event.formData;
                const emailField = getEpiformFieldByLabel('.FormTextbox', 'email', 'input');
                const iAmAField = getEpiformFieldByLabel('.FormSelection', 'i am a', 'select');

                let dataToPush = {
                    event: 'custom.form.complete',
                    // eslint-disable-next-line no-undef
                    user_type: userType,
                    // eslint-disable-next-line no-undef
                    form: formName,
                    action: 'complete',
                };

                if (emailField?.name) {
                    const userEmail = data.get(emailField.name);
                    if (isEmail(userEmail)) {
                        // email should be encrypted to sha256 for dataLayer.
                        hashedEmail = SHA256(userEmail).toString(enc.Hex);
                        dataToPush = {
                            ...dataToPush,
                            user_id: hashedEmail,
                        };
                    }
                }

                if (iAmAField?.name) {
                    const iAmValue = data.get(iAmAField?.name);
                    dataToPush = {
                        ...dataToPush,
                        user_i_am_a: iAmValue,
                    };
                }

                dataLayer.push(dataToPush);
            }

            // Track error submission
            if (!event.isSuccess) {
                const result = event.returnedResult;
                dataLayer.push({
                    event: 'custom.form.error',
                    // eslint-disable-next-line no-undef
                    form: formName,
                    action: 'error',
                    message: result.message,
                });
            }
        });

        // on pre-form submission
        $$epiforms('.EPiServerForms').on('formsStepValidating', event => {
            if (!event.isValid) {
                const message = 'Missing required field(s)';
                // To do : find a way to list the missing fields within the message.
                dataLayer.push({
                    event: 'custom.form.error',
                    // eslint-disable-next-line no-undef
                    form: formName,
                    action: 'error',
                    message,
                });
            }
        });

        // on input (text, number, textarea) value changes
        $$epiforms('.EPiServerForms .FormTextbox__Input').on('blur', event => {
            const input = event.target;
            const label = input.parentNode?.querySelector('.Form__Element__Caption');
            const { value } = input;
            let hashedEmail = '';

            if (!value) {
                // Do nothing if there's no value
                return;
            }

            if (isEmail(value)) {
                // email should be encrypted to sha256 for dataLayer.
                hashedEmail = SHA256(value).toString(enc.Hex);
            }

            dataLayer.push({
                event: 'custom.form.field',
                // eslint-disable-next-line no-undef
                form: formName,
                field: label?.textContent ?? '',
                value: hashedEmail === '' ? value : hashedEmail,
                action: 'field complete',
            });

            pushFormStart();
        });

        // to watch dropdown options fields change
        $$epiforms('.EPiServerForms .FormSelection select').on('change', event => {
            const selectField = event.target;
            const label = selectField.parentNode?.querySelector('.Form__Element__Caption');
            const { value } = selectField;

            if (!value) {
                // Do nothing if there's no value
                return;
            }

            dataLayer.push({
                event: 'custom.form.field',
                // eslint-disable-next-line no-undef
                form: formName,
                field: label?.textContent ?? '',
                value,
                action: 'field complete',
            });

            pushFormStart();
        });

        // to watch radio fields change
        $$epiforms('.EPiServerForms .FormChoice .FormChoice__Input--Radio, .EPiServerForms .FormChoice .FormChoice__Input--Checkbox').on('change', event => {
            const radio = event.target;
            const label = radio.parentNode?.parentNode?.querySelector('.Form__Element__Caption');
            const { value } = radio;

            if (!value) {
                // Do nothing if there's no value
                return;
            }

            dataLayer.push({
                event: 'custom.form.field',
                // eslint-disable-next-line no-undef
                form: formName,
                field: label?.textContent ?? '',
                value,
                action: 'field complete',
            });

            pushFormStart();
        });
    }
}
